module.exports = __webpack_public_path__ + "img/asset_thumb_placeholder.f33f7a72.webp";